import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTitanApp from "../../../hooks/useTitanApp";
import {
  setisPatientSearched,
  setPatientInfoTab,
  setRoutedFromScheduler,
  setShowPatientSearchModal,
} from "../../../dispatchers/appDispatchers";
import { LiaFilePrescriptionSolid, LiaSearchSolid } from "react-icons/lia";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { SlClose } from "react-icons/sl";
import { IoChevronForwardCircleOutline } from "react-icons/io5";
import "./../../../assets/css/GlobalPatientSearch.scss";
import CustomLoader from "../../controls/CustomLoader";
import CustomButton from "../../controls/CustomButton";
import AddPatientForm from "./AddPatientForm";
import {
  setIsPatientDashboard,
  setIsSelectedPatient,
  getPaymentAnalyticsByPatientId,
  setPatientSummary,
  setPatientAIChatMessages,
  setVaccineDetails,
  setPaymentAudit,
} from "../../../dispatchers/patientDispatchers";
import {
  setIsTemplateSelected,
  setSelectedTemplate,
  setSelectedTemplateContent,
} from "../../../dispatchers/templateDispatchers";
import LottieLoader from "../../controls/LottieLoader";
import AddPatientPopUp from "./AddPatientPopUp";

export default function GlobalPatientSearch() {
  const { appState, patientState } = useTitanApp();
  const { showPatientSearchModal, darkMode, currentPharmacyId } =
    appState || {};
  const { patientList, patientListLoader } = patientState || {};
  const navigate = useNavigate();
  const location = useLocation();
  const navigateFromDashboard =
    location.state && location?.state?.moveFromDashboard;
  const selectedPatientName =
    location.state && location?.state?.selectedPatientName;
  const selectedPatientAddress =
    location.state && location?.state?.selectedPatientAddress;
  const pharmacyAvgVal = location.state && location?.state?.pharmacyAvgVal;

  const [searchText, setSearchText] = useState("");
  const [filteredPatientList, setFilteredPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showAddPatientForm, setShowAddPatientForm] = useState(false);
  const handleClose = () => {
    setShowPatientSearchModal(false);
  };

  const handlePatientClick = (patient) => {
    const full = patient?.fullObject;
    const firstNameInitial = patient.name.charAt(0).toUpperCase();
    const lastNameInitial = patient.name.split(" ")[1]?.charAt(0).toUpperCase();
    const initials = lastNameInitial
      ? firstNameInitial + lastNameInitial
      : firstNameInitial;
    // setShowPatientSearchModal(false);
    setPaymentAudit(null);
    setisPatientSearched(true);
    setPatientInfoTab(0);
    setIsPatientDashboard(true);
    setSelectedTemplate([]);
    setIsTemplateSelected(false);
    setPatientSummary("");
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setRoutedFromScheduler(false);
    setVaccineDetails(null);
    setIsSelectedPatient(patient?.name);
    setSelectedPatient({
      ...patient,
      initials,
    });
    navigate(`patientdashboard/${currentPharmacyId}/${full?.patientID}`, {
      replace: true,
      state: {
        onDarkModeChange: darkMode,
        moveFromDashboard: navigateFromDashboard,
        selectedPatientName: selectedPatientName,
        selectedPatientAddress: selectedPatientAddress,
        pharmacyAvgVal: pharmacyAvgVal,
        latitude: 54.7023545,
        logitude: -3.2765753,
      },
    });

    setShowPatientSearchModal(false);
  };

  const handleInputChange = (e) => {
    const searchValue = e?.target?.value;
    setSearchText(searchValue);

    if (!searchValue.trim()) {
      setFilteredPatientList([]);
      setSelectedPatient(null);
      return;
    }

    const filteredPatients = patientList?.filter((patient) =>
      patient.patientName?.toLowerCase().includes(searchValue.toLowerCase())
    );
    // Map them to a structure compatible with your rendering logic
    const mappedPatients = filteredPatients.map((patient) => ({
      id: patient._id,
      name: patient.patientName,
      date: new Date(patient.dob).toLocaleDateString("en-GB"), // Or any preferred format
      fullObject: patient, // In case you need full data later
    }));

    setFilteredPatientList(mappedPatients);
  };

  const clearSearch = () => {
    setSearchText("");
    setFilteredPatientList([]);
    setSelectedPatient(null);
  };

  return (
    <>
      <Modal
        show={showPatientSearchModal}
        onHide={() => {
          setShowPatientSearchModal(false);
        }}
        backdrop="true"
        className="global-patient-search-modal"
        contentClassName="modal-height"
        dialogClassName="custom-modal-content custom-modal-width"
      >
        {showAddPatientForm ? (
          <AddPatientPopUp
            open={showAddPatientForm}
            onOpenChange={setShowAddPatientForm}
            onSave={(patient) => {}}
            isDarkMode={darkMode}
          />
        ) : (
          <>
            <Modal.Header style={{ padding: "10px 10px 0" }}>
              <div className="inputDiv">
                <span className="searchIcon">
                  <LiaSearchSolid size={20} className="icons-color" />
                </span>
                <input
                  value={searchText}
                  onChange={handleInputChange}
                  className="searchPatient"
                  placeholder="Search patient..."
                  type="text"
                />
                {searchText?.length > 0 && (
                  <div className="cross-icon">
                    <SlClose
                      className="cross icons-color"
                      onClick={clearSearch}
                      size={25}
                    />
                  </div>
                )}
                <button onClick={handleClose} className="suffix-button">
                  Close
                </button>
              </div>
            </Modal.Header>

            {patientListLoader ? (
              <LottieLoader />
            ) : filteredPatientList?.length === 0 ? (
              <div className="noRecordFound searchPatient">
                No record found
                <div style={{ marginTop: "10px" }}>
                  <CustomButton
                    label="Add Patient"
                    action={() => {
                      setShowAddPatientForm(true);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="parent">
                <div className="patients">
                  <div className="addPatient">
                    {filteredPatientList?.length > 0 && (
                      <div className="patientListHeading">Patient(s)</div>
                    )}
                  </div>

                  {filteredPatientList?.length > 0 ? (
                    <div className="patientList">
                      {filteredPatientList?.map((patient) => (
                        <div
                          className="rowPatient"
                          key={patient.id}
                          onClick={() => handlePatientClick(patient)}
                        >
                          <div>
                            <div className="patientName">
                              {patient?.name || ""}
                            </div>
                          </div>
                          <div>
                            <div className="date">{patient?.date || ""}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}

                  {/* {selectedPatient &&
                searchText?.trim() !== "" &&
                patientList?.length !== 0 && (
                  <div className="prescriptions">
                    <div className="prescriptionsHeading">Prescriptions</div>
                    <div className="addPrescriptions"></div>
                  </div>
                )} */}
                  {/* {selectedPatient &&
                searchText.trim() !== "" &&
                patientList?.length !== 0 && (
                  <div className="prescriptionList">
                    <div className="rowPrescription">
                      <div>
                        <LiaFilePrescriptionSolid
                          size={21}
                          className="icons-color"
                        />

                        <div className="prescriptionName">
                          RX ID 123-456-789
                        </div>
                      </div>

                      <div className="date">11/13/1982</div>
                    </div>
                    <div className="rowPrescription">
                      <div>
                        <LiaFilePrescriptionSolid
                          size={21}
                          className="icons-color"
                        />

                        <div className="prescriptionName">
                          RX ID 123-456-789
                        </div>
                      </div>

                      <div className="date">11/13/1982</div>
                    </div>
                    <div className="rowPrescription">
                      <div>
                        <LiaFilePrescriptionSolid
                          size={21}
                          className="icons-color"
                        />

                        <div className="prescriptionName">
                          RX ID 123-456-789
                        </div>
                      </div>

                      <div className="date">11/13/1982</div>
                    </div>
                  </div>
                )} */}
                </div>
                {selectedPatient &&
                  searchText.trim() !== "" &&
                  patientList?.length !== 0 && (
                    <div className="patientDetails">
                      <div className="patientContact">
                        {selectedPatient && (
                          <div className="circle">
                            <span className="initials">
                              {selectedPatient ? selectedPatient.initials : ""}
                            </span>
                          </div>
                        )}
                        <div className="patientDetailsName">
                          {" "}
                          {selectedPatient ? selectedPatient.name : ""}
                        </div>
                        <div className="patientDetailsDate">
                          11/13/1982 - (37)
                        </div>
                        {selectedPatient?.fullObject?.nhsNumber?.length > 0 && (
                          <div className="detailDigits">
                            {(selectedPatient?.fullObject?.nhsNumber || "")
                              .split("")
                              .map((digit, index) => (
                                <div key={index} className="rectangle">
                                  <span className="digit">{digit}</span>
                                </div>
                              ))}
                          </div>
                        )}

                        {selectedPatient?.fullObject?.address && (
                          <div className="patientDetailsAddress">
                            <p>{selectedPatient.fullObject.address}</p>
                          </div>
                        )}
                      </div>
                      <div className="drugsAndNominations">
                        {/*  */}

                        <div className="nominations">
                          <div className="nominationChild">
                            <div className="nominationHeading searchPatient">
                              Nominations
                            </div>
                            <div>
                              <IoChevronForwardCircleOutline
                                size={20}
                                color={darkMode ? "#f1f1f1" : "#0a0a0a"}
                              />
                            </div>
                          </div>
                          <div className="nominationAddress">
                            <p>
                              Invatech Health 442-450 Stapleton Rd, Bristol BS5
                              6NR UK
                            </p>
                          </div>
                        </div>
                        <div className="nominations">
                          <div className="nominationChild">
                            <div className="nominationHeading searchPatient">
                              Nominations
                            </div>
                            <div>
                              <IoChevronForwardCircleOutline
                                size={20}
                                color={darkMode ? "#f1f1f1" : "#0a0a0a"}
                              />
                            </div>
                          </div>
                          <div className="nominationAddress">
                            <p>
                              Invatech Health 442-450 Stapleton Rd, Bristol BS5
                              6NR UK
                            </p>
                          </div>
                        </div>
                        {selectedPatient?.fullObject?.patientTags?.length >
                          0 && (
                          <div className="tags">
                            <div className="tagsChild">
                              <div className="nominationHeading searchPatient">
                                Patient tags
                              </div>
                            </div>
                            <div className="tagSection">
                              {selectedPatient?.fullObject?.patientTags?.map(
                                (tag, index) => (
                                  <button key={index} className="singleTag">
                                    #{tag}
                                  </button>
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            )}
          </>
        )}
      </Modal>
    </>
  );
}
